import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import ProviderSettingsTab from "../components/ProviderSettingsTab";
import "../components/ProviderDetails.css";
import "./AccountSettings.css";

const AccountSettings = () => {
  const user = useSelector((state) => state?.user?.user);
  const providerId = user?.providerId;

  const [provider, setProvider] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadData = useCallback(async () => {
    if (!providerId) {
      setLoading(false);
      setError("Provider profile not found.");
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const providerRes = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/specialist/provider/${providerId}`,
        user?.token
          ? { headers: { Authorization: `Bearer ${user.token}` } }
          : undefined,
      );

      if (!providerRes.data?.success) {
        setError(
          providerRes.data?.message || "Failed to load account settings.",
        );
        return;
      }

      setProvider(providerRes.data.data);
    } catch (err) {
      setError(
        err.response?.data?.message || "Failed to load account settings.",
      );
    } finally {
      setLoading(false);
    }
  }, [providerId, user?.token]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  if (loading) {
    return (
      <div className="account-settings-page">
        <div className="account-settings-status">Loading account settings...</div>
      </div>
    );
  }

  if (error || !provider) {
    return (
      <div className="account-settings-page">
        <div className="account-settings-status is-error">
          {error || "Unable to load account settings."}
        </div>
      </div>
    );
  }

  return (
    <div className="account-settings-page">
      <div className="account-settings-header">
        <h1 className="account-settings-title">Account Settings</h1>
      </div>

      <ProviderSettingsTab
        provider={provider}
        getProviderId={() => providerId}
        onProviderUpdated={(next) => setProvider(next)}
      />
    </div>
  );
};

export default AccountSettings;
